import moment from 'moment'

import { ReserveSettings } from './ReserveSettings'

export interface Account {
  id: string
  name: string
  billingFrequency: string
  streetAddress: string
  city: string
  state: string
  zip: string
  country: string
  timezone: string
  website: string
  contactFirstName: string
  contactLastName: string
  contactEmail: string
  contactPhone: string
  hasCustomBusinessType: boolean
  businessTypeId: string
  strawberryFieldAccountId: string
  hasVisits: boolean
  selfServiceMatchingRatio?: number
  pxlUid: string
  created: moment.Moment
  defaultTargetingId?: string
  accountReserveSettings?: ReserveSettings
}

export interface AccountShopifyConnection {
  isConnected: boolean
  shop: string
}

export enum BillingProvider {
  Default = 'Default',
  Balance = 'Balance'
}
